import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const StyledMountText = styled.span`
  font-weight: ${themeGet('fontWeights.semiBold')};
  color: ${themeGet('colors.primary.extra')};
  font-size: ${themeGet('fontSizes.base')}px;
`;

export const StyledWrapper = styled.div`
  padding: 45px 16px 16px 16px;
  width: min(562px, 100vw - 40px);
  background-color: ${themeGet('colors.white')};
  box-shadow: ${themeGet('shadows.card')};
  border-radius: ${themeGet('radii.medium')};
  box-sizing: border-box;

  &.chooseProjects {
    ${StyledMountText} {
      font-size: ${themeGet('fontSizes.md')}px;
    }
  }

  &.enterRecipient {
    padding-bottom: 80px;
  }
`;

export const StyledLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  &:not(:last-child) {
    margin-bottom: 20px;
  }
`;

export const StyledCoinWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.4fr 1fr;

  &:not(:last-child) {
    margin-bottom: 45px;
  }
`;

export const StyledInputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 22px 10px 13px;
  border-width: 1px;
  border-style: solid;
  border-color: ${themeGet('colors.text.border')};
  border-radius: ${themeGet('radii.small')};

  &:not(:last-child) {
    margin-bottom: 16px;
  }
`;

export const StyledInputLabel = styled.span`
  font-weight: ${themeGet('fontWeights.semiBold')};
  font-size: ${themeGet('fontSizes.xs')}px;
  color: ${themeGet('colors.input.placeholder')};
`;

export const StyledInputValue = styled.span`
  font-weight: ${themeGet('fontWeights.semi')};
  font-size: ${themeGet('fontSizes.base')}px;
  color: ${themeGet('colors.primary.extra')};
`;

export const StyledCoinList = styled.ul`
  padding: 0;
`;

export const StyledCoinItem = styled.li`
  list-style-type: none;
  text-align: center;

  &:not(:last-child) {
    margin-bottom: 5px;
  }
`;

export const StyledTextWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export const StyledCoin = styled.span`
  position: relative;
  display: flex;
  align-items: center;

  .custom-tooltip {
    position: absolute;
    top: 50%;
    right: -35px;
    transform: translate(-50%, -50%);
  }
`;

export const StyledCoinMount = styled.span`
  line-height: 60px;
  align-items: center;
  text-align: center;
  font-weight: ${themeGet('fontWeights.semiBold')};
  color: ${themeGet('colors.secondary.regular')};
  font-size: ${themeGet('fontSizes.xl')}px;
`;

export const StyledIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: ${themeGet('colors.primary.extra')};
`;

export const StyledLabel = styled.label`
  display: block;
  font-size: ${themeGet('fontSizes.xs')}px;
  font-weight: ${themeGet('fontWeights.semi')};
  color: ${themeGet('colors.text.default')};
  margin-bottom: 4px;
  line-height: 18px;
`;
